import $ from 'cash-dom';

const Countdown = {
	_intervalId: null,
	init() {
		const self = this;

		if (!$('.countdown[data-deadline], .countdown[data-time-left]').length) {
			return false;
		}

		this._initUI();

		// Paint before the first interval tick: a countdown injected after page load
		// (the exit popup) would otherwise show 00:00:00 for up to a second.
		this._runCountdownTimer();

		setTimeout(function () {
			$('.countdown[data-deadline], .countdown[data-time-left]').css({opacity: 1});
		}, 1000);

		if (this._intervalId) {
			return true;
		}

		this._intervalId = setInterval(function () {
			self._runCountdownTimer();
		}, 1000);
	},
	_initUI() {
		const generalCountdownHeight = $('.general-countdown-holder').outerHeight();

		if (generalCountdownHeight) {
			document.documentElement.style.setProperty('--general-countdown-half-height', (generalCountdownHeight / 2) + 'px');
		}
	},

	_deadline($el) {
		let deadline = parseInt($el.data('deadline-ts'), 10);

		if (deadline > 0) {
			return deadline;
		}

		const raw = $el.data('deadline');

		if (raw === 'end-of-tomorrow') {
			const endOfTomorrow = new Date();
			endOfTomorrow.setDate(endOfTomorrow.getDate() + 1);
			endOfTomorrow.setHours(23, 59, 59, 0);
			deadline = Math.floor(endOfTomorrow.getTime() / 1000);
		} else {
			deadline = parseInt(raw, 10);
		}

		if (!(deadline > 0)) {
			// No deadline given - treat data-time-left as a duration from right now.
			deadline = Math.floor(Date.now() / 1000) + (parseInt($el.data('time-left'), 10) || 0);
		}

		$el.data('deadline-ts', deadline);

		return deadline;
	},
	_stopTimer() {
		clearInterval(this._intervalId);
		this._intervalId = null;
	},
	_runCountdownTimer() {
		const self = this;
		let running = 0;

		$('.countdown[data-deadline], .countdown[data-time-left]').each(function () {
			const distance = Math.max(0, self._deadline($(this)) - Math.floor(Date.now() / 1000));

			if (distance < 1) {
				self._showAfterCountdownText(this);
			} else {
				running++;
			}

			let days = Math.floor(distance / (60 * 60 * 24)).toString(),
				hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60)).toString(),
				minutes = Math.floor((distance % (60 * 60)) / (60)).toString(),
				seconds = Math.floor((distance % 60)).toString();

			if (days.length < 2) {
				days = '0' + days;
			}

			if (hours.length < 2) {
				hours = '0' + hours;
			}

			if (minutes.length < 2) {
				minutes = '0' + minutes;
			}

			if (seconds.length < 2) {
				seconds = '0' + seconds;
			}

			$(this).find('[data-countdown]').each(function () {
				switch ($(this).data('countdown')) {
					case 'days':
						self._setTime(this, days);
						break;
					case 'hours':
						self._setTime(this, hours);
						break;
					case 'minutes':
						self._setTime(this, minutes);
						break;
					case 'seconds':
						self._setTime(this, seconds);
						break;
				}

			});
		});

		// Only stop once every countdown on the page has expired.
		if (!running) {
			this._stopTimer();
		}
	},
	_setTime($timeContainer, timeText) {
		$timeContainer = $($timeContainer);
		let textToSet = String(timeText);

		if ($timeContainer.hasClass('separate-digits')) {
			const [firstDigit, secondDigit] = timeText.split('');
			textToSet = `<div class="first-digit">${firstDigit}</div><div class="second-digit">${secondDigit}</div>`;
		}

		$timeContainer.html(textToSet);
	},
	_showAfterCountdownText(el) {
		const $countdown = $(el);
		if ($countdown.hasClass('hidden')) {
			return;
		}

		const $textAfterCountdown = $countdown.parent().find('.text-after-countdown');

		if ($textAfterCountdown.length) {
			$textAfterCountdown.removeClass('hidden');
			$countdown.addClass('hidden');
		}
	},
};

export default Countdown;
